import React from 'react'
import { useCurrentRefinements } from 'react-instantsearch';
import styles from "./PLPSelectedFilters.module.scss"
import { useDispatch } from "react-redux";
import { setPriceAction } from '@/redux/actions/priceAction';
import { renderEngraveFilterLabel } from '../filters-utils';
import useMediaQuery from '@/helpers/hooks/useMediaQuery';



const PLPSelectedFiltersComp = (props) => {
  //  get the current refined items( items which are clicked from the filter)
  const { items, refine } = useCurrentRefinements(props);
  let initialRefinement = props.initialRefinement;
  const dispatch = useDispatch();

  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1023px)"); 
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  const clickHandler = (refinement,priceRefinement) => {
    // checks whether the  element is clicked or not
    // the if condition will get executed only if in the price filter min max filter is applied
    // here we are manually removing both min and max filter
    if(refinement.attribute === 'price' &&  priceRefinement.length > 1) {
      refine(priceRefinement[0]);
      refine(priceRefinement[1]);
      //redux state is set to clear the min max value from input field
      dispatch(setPriceAction(true))
    } else {
      refine(refinement);
    }
  };

  var count_one, count_two = 0;

  // excluding the  level0 refined items.
  //  For new-arrivals  category 0 pills should show on PLP
  let filteredData = !typeof url === 'string' && url.includes('new-arrivals') ? items.filter(item => item.attribute !== "named_tags.categories.lvl0") : items;

  //  counting total number of items.
  const filteredDataLength = filteredData.map(data => {
    if (data.attribute === "named_tags.categories.lvl1") {
      count_one = data.refinements.length;
      return count_one;
    }
    if (data.attribute === "named_tags.categories.lvl2") {
      count_two = count_one + count_two;
      return count_two;
    }
  }
  );

  function getPriceFilterCustomData(singleLevelFilters) {
    let priceLabel = '';
    let priceRefinement = [];
    let ret = {};
    if(singleLevelFilters.attribute === 'price'){
      // when min max is applied we get it as 2 refinements, which we are clubing it as single pill
      if(singleLevelFilters.refinements.length > 1) {
        singleLevelFilters.refinements.forEach(refinement => {
          if(refinement.label.indexOf('≥ ') != -1){
            let ar = refinement.label.split("≥ ");
            priceLabel += '$'+ar[ar.length - 1]+' - ';
          }
          else if(refinement.label.indexOf('≤ ') != -1){
            let ar = refinement.label.split("≤ ");
            priceLabel += '$'+ar[ar.length - 1];
          }
          priceRefinement.push(refinement);
        })
      } else {
        //for price radio button values we are just manipulating the values
        singleLevelFilters.refinements.map((refinement, index) => {
          if (refinement.attribute === "price") {
            if(refinement.label.indexOf('≥ ') != -1){
              let ar = refinement.label.split("≥ ");
              priceLabel = '$'+ar[ar.length - 1]+ ' and above';
            }
            else if(refinement.label.indexOf('≤ ') != -1){
              let ar = refinement.label.split("≤ ");
              priceLabel = '$'+ar[ar.length - 1]+ ' and under';
            }
          }
        })
      }
    }
    //priceRefinement array is specifically used in clear refinement to clear both min and max filter
    ret['priceLabel'] = priceLabel;
    ret['priceRefinement'] = priceRefinement;
    return ret;
  }

  // removing the default selected filters from the filter pills
  filteredData= filteredData.map((data) => {
  const {refinements} = data
  const refinementsToBeAdded = refinements.filter((elem) => elem.label != [initialRefinement[data.attribute]])
  return {...data, refinements : refinementsToBeAdded }
  }).filter((elem) => elem?.refinements?.length > 0)

  
  // adding the level1 and level2 count
  let sumOfEle = 0;
  filteredData.forEach(item => {
    //since when min max ilter is applied we are getting it as 2 refinements instead of 1, hence we are subtracting 1 here
    if (item.refinements.length) {
      if(item.attribute === 'price' && item.refinements.length > 1) {
        sumOfEle = sumOfEle + (item.refinements.length-1);
      } else {
        sumOfEle = sumOfEle + item.refinements.length;
      }
    }
  })

  const removeAllItems = () => {
    // clear out all the filter.
    const newUrl = props?.seoData?.search_query ? `${location.pathname}?query=${props?.seoData?.search_query}` : location.pathname;
    window.location.href = newUrl;
  }

  return (
    <div className={`${styles.filter_view}`}>
      <div className={`${styles.filter_total}`}>
        {filteredData.length ? (
          <>
            <span className="x-small-sm x-small-md xx-small-xs">{sumOfEle}</span>
            <div className={styles.filter_remove} onClick={removeAllItems}>
              <img src={`${process.env.NETLIFY_URL}/icons/Cross/Large-sm.svg`} alt="filter remove" />
            </div>
          </>
        ) : (
          <div></div>
        )}
      </div>
      {filteredData.map((singleLevelFilters) => {
        //In the below code for price attribute we are manually doing label chnages to be shown to the user
        //Also we are clubing the refinements of min max filter to single value
        //hence in clickHandler function as well we have price specific condition in case of min max to clear both the refinement
        let priceLabel = '';
        let priceRefinement = [];
        if(singleLevelFilters.attribute === 'price'){
          let priceCustomData = getPriceFilterCustomData(singleLevelFilters);
          priceLabel= priceCustomData.priceLabel;
          priceRefinement = priceCustomData.priceRefinement;
        } 
        let minMaxAdded = 0;
        return singleLevelFilters.refinements.map((refinement, index) => {
          
          if(refinement.attribute === "price" && minMaxAdded) {
            return;
          }
          const levelLabelsArray = refinement.label.split(">");
          let actualLabel = (refinement.attribute === "price") ? priceLabel : levelLabelsArray[levelLabelsArray.length - 1];
          //OS-5231 #the tags name and dispaly name do not match hence handled
          if(refinement.attribute === "named_tags.Tag_curated" || refinement.attribute === "named_tags.Tag2" || refinement.attribute === "named_tags.Tag1") {
            actualLabel = renderEngraveFilterLabel(refinement)
          }
          if(refinement.attribute === "price") {
            minMaxAdded = 1;
          }
          return (
            (sumOfEle <= 7 && isDesktop) || (sumOfEle <= 4 && isTablet) ? ( //do not not display this section if applied filters greater than 7 for desktop & 4 for ipad respectively
            <div className={`${styles.filter_item}`} key={index}>
              <div className={`${styles.select_filter} small`} >{actualLabel}</div>
              <div className={`${styles.filter_remove}`} onClick={() => clickHandler(refinement,priceRefinement)}><img src={`${process.env.NETLIFY_URL}/icons/Cross/Large-sm.svg`} alt="filter remove" /></div>
            </div>
            ) : null
          );
        });
      })}
    </div>
  );
};

export default PLPSelectedFiltersComp